import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import { Redirect, Route, withRouter } from "react-router-dom";

@inject("context")
@withRouter
@observer
class PrivateRoute extends Component {
	render() {
		const { component: Cmp, context, ...rest } = this.props;

		return (
			<Route
				{...rest}
				render={(props) =>
					context.applicationService.isAuthenticated === true ? (
						<Cmp {...props} />
					) : (
						<Redirect
							to={{
								pathname: "/login",
								state: {
									from: this.props.location.pathname,
								},
							}}
						/>
					)
				}
			/>
		);
	}
}

export default PrivateRoute;
